<section class="ip-payment-history" *ngIf="this.isLoaded">
  <app-fn-mobile-table-header [titleTranslate]="
    this.selectedSupplierId ?
    'IP.SIDENAV.OPTIONS.FINANCE' :
    'IP.SIDENAV.OPTIONS.MY_FINANCE'
  "/>

  <app-back-navigate-button
    *ngIf="this.selectedSupplierId"
    [returnUrl]="'invopay/finance/provider-accounts'"
    [backLabel]="this.businessName || 'Volver'"
  ></app-back-navigate-button>

  <div class="ip-payment-history__header">
    <div class="ip-payment-history__header-section-title">
      {{ "IP.SIDENAV.OPTIONS.MY_FINANCE" | translate }}
    </div>
  </div>

  <div class="ip-payment-history__mobile">
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      animationDuration="0ms"
      class="ip-payment-history__table"
    >
      <mat-tab class="label-tab" label="Datos de cuenta">
        <app-fn-account-info [selectedSupplierId]="this.selectedSupplierId" />
        <app-fn-account-transactions
          [selectedSupplierId]="this.selectedSupplierId"
        />
      </mat-tab>
      <mat-tab class="label-tab" label="Tarjeta de débito">
        <app-fn-card-info [selectedSupplierId]="this.selectedSupplierId" />
        <app-fn-card-transactions
          [selectedSupplierId]="this.selectedSupplierId"
        />
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
